import React, {useEffect, useMemo, useState} from 'react';
import {Bubble, Button, Dropdown, List, Modal,} from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import type { IGetTableInfoDto } from '@dbl/services/dataSource';
import { convertCustomColumnToColumnRawInfo, CustomColumn } from '@/pages/datalab/pages/Multidimensional/Analysis/interface';
import {ReactSortable} from 'react-sortablejs';
import type { IColumnInfo, IColumnRawInfo } from '@dbl/core/dataSource';
import {dragOnMove, initDragStatus} from '@/pages/datalab/components/SortableDrag/utils';
import {TDispatchFun, SortableItems} from '@/pages/datalab/components/SortableDrag/configration';
import {useDblIntl} from "@/pages/datalab/utils/utils";
import {EditList} from "@/pages/datalab/components/SortableDrag/FieldEditComponents";
import {ITableJoinRelation} from "@/pages/datalab/pages/Multidimensional/Analysis/components/HeaderData/interface";
import { FieldType } from '@dbl/core/dataSource';

const FieldTypeIcon = {
  'date': 'date',
  'time': 'time',
  'string': 'abc',
  'number': 'a-123',
  'float': 'a-123',
  'percent': 'a-123',
};
let currentDragItem: IColumnInfo | null = null;
export default function MenuTabCustom(props: any) {
  const {
    namespace,
    customColumns=[],
    deleteField,
    showFieldDefine,
    updateColumn,
    dataTables,
    dataTableJoinRelations,
  }: {
    namespace: string;
    customColumns: CustomColumn[];
    deleteField?: (customColumn: CustomColumn) => void;
    showFieldDefine?: (e: any, customColumn?: CustomColumn) => void;
    updateColumn?: (column: CustomColumn) => void;
    dataTables: IGetTableInfoDto[];
    dataTableJoinRelations: ITableJoinRelation[];
  } = props;
  const { dblFormatMessage: multiFormatMessage, commonFormatMessage, isEn} = useDblIntl("multi");
  
  const [isShow, setIsShow] = useState(false);
  // const [delectData, setDelectData] = useState(false);
  const [delectField, setDelectField] = useState(false);
  const [deleteFieldData, setDeleteFieldData] = useState<CustomColumn>();
  // const [columnBubbleVisible, setColumnBubbleVisible] = useState(true);
  const [editingId, setEditingId] = useState<string>('');
  
  useEffect(() => {
    setIsShow(value => {
      const hasColumns = customColumns?.length > 0;
      return value !== hasColumns ? hasColumns : value;
    });
  }, [customColumns?.length]);
  
  const customSortableLists = useMemo(
    () => (customColumns || []).map((customColumn) => convertCustomColumnToColumnRawInfo(customColumn)),
    [customColumns],
  );

  const dragOnMoveHandle = (evt: any, originalEvent: any) => {
    const { to } = evt;
    const sortableClass = to.className.split(' ').find((item: string) => item.includes(`-${SortableItems}`));
    const sortableKey = sortableClass.slice(0, sortableClass.indexOf(`-${SortableItems}`));
    const { [sortableKey]: columnInfos } = props;
    return dragOnMove(evt, originalEvent, sortableKey, columnInfos, dispatchFun, currentDragItem);
  };

  const dispatchFun: TDispatchFun = (path: string, payload: {}, callback?: Function) => {
    props.dispatch({
      type: `${namespace}/${path}`,
      payload,
      callback,
    });
  };
  return (
    <div className="field_list">
      <div className="field_list-bh">
        <div
          className="bh-show"
          onClick={() => {
            setIsShow(!isShow);
          }}
        >
          <SvgIcon type="point-down" className={isShow ? 'bh-action' : 'bh-change'} />
          <span className="bh-text">{multiFormatMessage("add_field_list")}</span>
        </div>
        <div
          className="bh-btn"
          onClick={(e) => {
            showFieldDefine?.(e);
          }}
        >
          {commonFormatMessage("add")}
        </div>
      </div>
      {
        <div className={isShow ? 'field_list-bd height-nomal' : 'field_list-bd height-0'} onMouseDown={(event) => {event.preventDefault()}}>
          <ReactSortable
            group={{
              name: 'groupName',
              pull: 'clone',
              put: false,
            }}
            dragClass="colunm-drag"
            sort={false}
            handle={'.colunm-item-wrap'}
            animation={0}
            // delay={50}
            forceFallback={true}
            list={customSortableLists}
            setList={() => {}}
            onStart={(evt) => {
              currentDragItem = customSortableLists[evt.oldIndex || 0];
              // setColumnBubbleVisible(false);
            }}
            onMove={dragOnMoveHandle}
            onEnd={() => {
              initDragStatus(dispatchFun);
              // setColumnBubbleVisible(true);
            }}
          >
            {customColumns?.map((customColumn: CustomColumn, index) => (
              <Bubble
                placement="top"
                key={index}
                dark
                content={
                  customColumn.remark &&
                  (<div style={{maxWidth: 400}}>
                    <p>{customColumn.remark}</p>
				          </div>)
                }
              >
                <div className={`bd-flex colunm-item-wrap ${editingId === customColumn.id ? 'editing' : ''}`} key={index}>
                  <SvgIcon type={FieldTypeIcon[customColumn.column_type] || "abc"} className={'column-item-type'}/>
                  <div className="bd-flex-left">
                    <div className="bd-flex-text">{isEn ? customColumn.name_en : customColumn.name_cn}</div>
                    <div className="bd-flex-desc">{customColumn.name_en}</div>
                  </div>
                  <div className="bd-flex-right">
                    <Dropdown
                      className={'column-item-more'}
                      boxClassName={'column-item-drop'}
                      updateOnChildrenChange={true}
                      placementOffset={[-14, 8]}
                      placement={"right-start"}
                      clickClose={false}
                      button={<SvgIcon type={'more'} className="bd-flex-icon"/>}
                      appearance={'pure'}
                      onOpenChange={(open) => {
                        setEditingId(open ? customColumn.id : '');
                      }}
                    >
                      {
                        (close) => (<EditList
                          key={index}
                          className={'column-item-drop-edit'}
                          options={[
                            {type: 'custom', render: () => (<List.Item onClick={(e) => {showFieldDefine?.(e, customColumn);close()}
                            }>{multiFormatMessage("filed_edit")}</List.Item>)},
                            {type: 'fieldType', value: customColumn.column_type, decimal: customColumn.accuracy, onChange: (column: IColumnRawInfo, updateInfo: any) => {
                              updateColumn?.({...column, ...updateInfo});
                            },
                            customDateCheckParams: { // 用于自定义字段 转换日期格式的传参
                              expression: customColumn.sql_expression,
                              table_id: dataTables[0]?.table_id || '',
                              column: 'CustomField',
                              custom_column: {
                                custom_columns: [{
                                  name_cn: 'CustomField',
                                  column_type: 'float',
                                  name_en: 'CustomField',
                                  sql_expression: customColumn.sql_expression,
                                  accuracy: 2,
                                }],
                                data_tables: dataTables,
                                table_infos: dataTableJoinRelations,
                                metrics: [
                                  {
                                    table_code: 't0',
                                    table_id: '',
                                    column: 'CustomField',
                                    label: 'CustomField',
                                    label_en: 'CustomField',
                                    column_type: 'string',
                                    aggregate: '',
                                    accuracy: 2,
                                    to_date_format: '',
                                  }
                                ]
                              }
                            }
                            },
                            {type: 'displayFormat', disabled: ![FieldType.Number, FieldType.Percent, FieldType.Float].includes(customColumn?.column_type), hideUnit: customColumn?.column_type === FieldType.Percent, accuracy: customColumn.accuracy, unit: customColumn.unit, onChange: (column: IColumnRawInfo, updateInfo: any) => {
                              updateColumn?.({...column, ...updateInfo});
                            }},
                            {type: 'custom', render: () => (<List.Item onClick={() => {
                              setDeleteFieldData(customColumn);
                              setDelectField(true);
                              close();
                            }
                            }>{multiFormatMessage("filed_delete")}</List.Item>)},
                          ]}
                          close={close}
                          column={customColumn}
                        />)
                      }

                    </Dropdown>
                    
                  </div>
                </div>
              </Bubble>
            ))}
          </ReactSortable>
        </div>
      }
      <DelectField
        data={deleteFieldData}
        delectData={delectField}
        close={() => {
          setDelectField?.(false);
        }}
        confirm={(data: any) => {
          deleteField?.(data);
        }}
        isEn={isEn}
      />
    </div>
  );
}

const DelectField = (props: any) => {
  const { data, delectData, confirm, close, isEn } = props;
  return (
    <Modal
      visible={delectData}
      onClose={() => {
        close?.();
      }}
    >
      <Modal.Body>
        <div className="model-delect">
          <div className="model-delect-title">{isEn? "Are you sure to delete the field?" : "确定删除字段？"}</div>
          <div className="model-delect-text">
            {
              isEn ? (<>Deleting field <span className="action">{data?.name_en}</span> will reanalyze</>) :
                (<>删除字段 <span className="action">{data?.name_cn}</span>  将重新进行分析</>)
            }
            
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="primary"
          onClick={() => {
            close?.();
            confirm?.(data);
          }}
        >
          {isEn ? 'Confirm' : '确定'}
        </Button>
        <Button
          type="weak"
          onClick={() => {
            close?.();
          }}
        >
          {isEn ? 'Cancel' : '取消'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
